module.exports = "data:image/webp;base64,UklGRj4AAABXRUJQVlA4TDEAAAAvD8AEEBcgkE12f6y84hASJPh/r32iBAJJ/pSbHH10wCDbSL0jO7T3zwNE9D/DvCkHAA=="